/** Cookie name for UI locale — safe to import from Client Components (no `next/headers`). */
export const LOCALE_COOKIE_NAME = "petromin-locale";
